module.exports = __webpack_public_path__ + "static/media/wafflesMobile.12c79ab4.svg";